///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';

export const _window = (): any => {
    // return the global native browser window object
    return window;
};

@Injectable()
export class WindowRef {
    get nativeWindow(): any {
        return _window();
    }
}
